// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:35:15+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            7978048834bd8f1fbd896224cd044fc3
//    Signature:      eyJpdiI6IlpNQVRYUW9VSHhlaTlVc0h1V0Vxd3c9PSIsInZhbHVlIjoidE1UXC91dVFcL0tGNmFuakUwS1IwZXBMZ1wvb3BSMUR1ODFBREREXC9NM0d1YW9oaEtoNjl2akxaM2tmaGZ1N0hkaEdva2pjSHppb05qZGh5UndSdDBRR1ZCQTRiOXR3amZWUUg5Um9rdGVxZnNqdnZFWnFVeWJ1NFdWOHI1YjRJZ3ZcL0h6RVlyNGI2MUN4RVRaTTlmUkdnQ05xNkFxeTV1RlRsYjNCWDNGbExVbnhcL0ZzMFhhQktRXC9UM3JsSDNxWmpqUXpsTGlpM00zSCtxdEtZOEp6NFBjZGMyb1J3bTBJaUdrcjBBUFFhMVVtaG9IaVhKQ1BmaTBLMjJ3SEZuSHVMTWtaUHFtUDBUamZpRWpId0c0WkNPTEppXC9IUUJ5cnpSSWp4VFh5QkpnUjl2aTlKOEE5U2NIam11WGtFYStBUXFhMTRhaE9rdHBqelordHhXY3RscTdIOGxucllleCtZZWpBQ3ZpNGxyaHZPMUVPQTRHaVZWalkyVW1cL0ZNd1k1c3JwUXQ3c2ZnXC9rY3UzSEFFN0FTK0pFM1E9PSIsIm1hYyI6IjgxZjVlNGRiZGJiMDczNDk0MjE5NGIyZGRmOGZkOWUyMTNiNzlkMDlmNWFhNGRlOGYyMzdmOTQ2YTQzNjU0N2EifQ==
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if(!this.form) return
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
